import React from "react";
import { useLocation } from "react-router";
import { observer } from "mobx-react-lite";

import {
  IonAvatar,
  IonButton,
  IonItem,
  IonLabel,
  IonIcon,
  IonSkeletonText,
} from "@ionic/react";

import { personCircle } from "ionicons/icons";

interface StandardResponseCategoriesListItemProps {
  category: string;
  onSelectItem: (item: string) => void;
}

const StandardResponseCategoriesListItem: React.FC<StandardResponseCategoriesListItemProps> =
  observer(({ category, onSelectItem }) => {
    const location = useLocation();

    if (category) {
      return (
        <IonItem onClick={() => onSelectItem(category)} detail={false} button>
          <IonLabel>
            <h2>{category}</h2>
          </IonLabel>
        </IonItem>
      );
    }

    return (
      <IonItem>
        <IonAvatar
          slot="start"
          style={{
            height: "50px",
            width: "50px",
          }}
        >
          <IonIcon
            icon={personCircle}
            color="medium"
            style={{ fontSize: "50px" }}
          ></IonIcon>
        </IonAvatar>
        <IonLabel>
          <h2>
            <IonSkeletonText animated style={{ width: "70%" }} slot="start" />
          </h2>
        </IonLabel>
      </IonItem>
    );
  });

export default StandardResponseCategoriesListItem;
